import { VueModule } from '@Foundation/utilities';
import ProductGallery from './code/Scripts/components/ProductGallery/ProductGallery.vue';
export default VueModule({
  components: {
    ProductGallery  }
});
